"use strict";
/// <reference path="../../app.typings.d.ts" />
var app;
(function (app) {
    var Services;
    (function (Services) {
        var MockService = /** @class */ (function () {
            function MockService($q) {
                this.$q = $q;
            }
            MockService.prototype.getErMock = function (report) {
                var mockReport = ap.MockData.reports[report];
                return this.$q(function (resolve) {
                    resolve(mockReport);
                });
            };
            MockService.$inject = ['$q'];
            return MockService;
        }());
        Services.MockService = MockService;
        angular.module('app.Services')
            .service('mockService', MockService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
